export default __webpack_public_path__ + "static/media/popcorn-pieces-01.5861d1b1.png";